import { createSlice } from "@reduxjs/toolkit";
export const roleSlice = createSlice({
  name: "role",
  initialState: {
    value: sessionStorage.getItem("role")
      ? JSON.parse(sessionStorage.getItem("role"))
      : undefined,
  },
  reducers: {
    setCompany: (state, action) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      if (action.payload !== undefined) {
        state.value = action.payload;
        sessionStorage.setItem("role", JSON.stringify(action.payload));
      } else {
        state.value = undefined;
        sessionStorage.setItem("role", undefined);
      }

      return state;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setRole } = roleSlice.actions;

export default roleSlice.reducer;
